import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import translation from 'translation';


const projectConnectionsRoutes = [
  {
    path: 'connections',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Connections')
      }
    },
    children: [
      {
        path: 'create',
        name: 'projectConnectionCreate',
        component: () => asyncLoadView(import('pages/connections/connections/CreateConnectionPage')),
        props: routeArgsToInt
      },
      {
        path: ':parentConnectionId(\\d+)/subconnection',
        name: 'projectConnectionCreateSubconnection',
        component: () => asyncLoadView(import('pages/connections/connections/CreateSubconnectionPage')),
        props: routeArgsToInt
      },
      {
        path: 'pending/:pendingConnectionId(\\d+)/subconnection',
        name: 'projectConnectionCreatePendingSubconnection',
        component: () => asyncLoadView(import('pages/connections/connections/CreatePendingSubconnectionPage')),
        props: routeArgsToInt
      },
      {
        path: ':connectionId(\\d+)/currency',
        name: 'projectConnectionCurrencySetup',
        component: () => asyncLoadView(import('pages/connections/connections/SetupConnectionCurrencyPage')),
        props: routeArgsToInt
      }
    ]
  }
];

export default projectConnectionsRoutes;
